import React, { useState, useEffect } from 'react';
import { Pressable, ScrollView, TouchableOpacity, Vibration, View } from 'react-native'

import api from "../../../utils/api"
import tw from '../../../styles/tailwind';
import Text from '../../../components/Text';
import { Icon } from '../../../components/Icon';
import Mascara from '../../Main/mascara.svg';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Image } from 'expo-image';
import { CameraView, FlashMode, useCameraPermissions } from 'expo-camera';
import { useFullScreenCameraStyle } from '../../Main/QRScannerScreen';
import { useNavigation } from '@react-navigation/native';
import IconButton from '../../../components/IconButton';
import GuardAccessAuthorizationDetailModal from './Access/GuardAccessAuthorizationDetailModal';


function QRResult({ scannedCode, onClear, onAuthorization }) {
  const [successMessage, setSuccessMessage] = useState(null);
  const [validatedPass, setValidatedPass] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);



  useEffect(() => {
    validateCode()
  }, []);


  function validateCode() {
    const data = {
      code: scannedCode,
      // Si es de una responsiva no se registra aquí: se abre el detalle para capturar evidencia
      authorization_flow: true,
    }

    setIsLoading(true)
    setErrorMessage(null)
    setSuccessMessage(null)
    setValidatedPass(null)

    api.post(`/entry-passes/validate`, data)
      .then(({ data }) => {
        setIsLoading(false)

        if (data.action === 'register_authorization') {
          onAuthorization?.(data.authorization)
          return
        }

        setSuccessMessage(data.message)
        setValidatedPass(data.pass)
      })
      .catch(({ response }) => {
        setIsLoading(false)
        console.log("error", response.data);

        setErrorMessage(response.data?.error?.message ?? "Error de red")
        setValidatedPass(response.data?.pass ?? null)

      })
  }

  return (
    <View style={tw`absolute rounded-xl overflow-hidden bg-white items-center pt-8 pb-9 px-8`}>
      {
        isLoading &&
        <>
          <Text style={tw`font-bold text-primary text-2xl pt-2 pb-2 text-center`}>Validando acceso</Text>
        </>
      }

      {
        successMessage &&
        <>
          <Text style={tw`font-bold text-primary text-2xl pt-2 pb-6 text-center`}>Pase válido</Text>

          {
            validatedPass &&
              <View style={tw`mb-6`}>
                <Text style={tw`font-500 text-xl text-center`}>{validatedPass.guest_name}</Text>
                <Text style={tw`font-500 text-gray-500 mb-4 text-lg text-center`}>{validatedPass.unit?.name}</Text>
                <Text style={tw`text-gray-400 text-lg text-center`}>{validatedPass.guest_type_str}</Text>
                <Text style={tw`text-gray-400 text-lg text-center`}>{validatedPass.periodicity_str}</Text>
              </View>
          }
          <IconButton title={'Cerrar'} icon='close' onPress={onClear} />
        </>
      }

      {
        errorMessage &&
        <>
          <Text style={tw`font-bold text-red text-xl pt-2 pb-6 text-center`}>{errorMessage}</Text>

          {
            validatedPass &&
            <View style={tw`mb-6`}>
              <Text style={tw`font-500 text-xl text-center`}>{validatedPass.guest_name}</Text>
              <Text style={tw`font-500 text-gray-500 mb-4 text-lg text-center`}>{validatedPass.unit?.name}</Text>
              <Text style={tw`text-gray-400 text-lg text-center`}>{validatedPass.guest_type_str}</Text>
              <Text style={tw`text-gray-400 text-lg text-center`}>{validatedPass.periodicity_str}</Text>
            </View>
          }

          <IconButton title={'Escanear de nuevo'} onPress={onClear} />
        </>
      }

    </View>
  )
}


export default function QRScannerModal({ onRequestClose, communityId }) {
  const [scannedAuthorization, setScannedAuthorization] = useState(null);
  const [hasPermission, setHasPermission] = useState(null);
  const [scanned, setScanned] = useState(false);
  const [codeType, setCodeType] = useState();
  const [torchOn, setTorchOn] = useState(false);
  const [isFocused, setIsFocused] = useState(true);

  const navigation = useNavigation()


  const { cameraStyle, contentStyle } = useFullScreenCameraStyle();
  const [permission, requestPermission] = useCameraPermissions();


  useEffect(() => {
    navigation.addListener('focus', () => {
      setIsFocused(true)
    })

    navigation.addListener('blur', () => {
      setIsFocused(false)
    });
  }, []);



  useEffect(() => {
    requestPermission()
  }, []);


  const handleBarCodeScanned = ({ type, data }) => {
    setScanned(data);
    setCodeType(type)
    Vibration.vibrate()
  };


  return (
    <>
      <Pressable style={tw`absolute bg-black/75 top-0 bottom-0 right-0 left-0`} onPress={onRequestClose} />

      <View style={tw`absolute overflow-hidden top-20% right-10 bottom-20% left-10 rounded-xl`}>
        {
          isFocused &&
            <CameraView
              enableTorch={torchOn ? true : false}
              onBarcodeScanned={scanned ? undefined : handleBarCodeScanned}
              barcodeScannerSettings={{
                barcodeTypes: ['qr'],
              }}
              onMountError={error => console.log({ error })}
              style={tw.style(`absolute left-0 right-0 top-0 bottom-0`, cameraStyle)}
            ></CameraView>
        }

        {/* slice: la máscara (SVG alto y delgado) cubre el recuadro ajustándose al ancho y
            recorta arriba/abajo; con el ajuste por defecto (al alto) faltaban los lados morados.
            El hueco del QR está al centro del dibujo, así que queda centrado. */}
        {/* El contenedor lleva la posición (márgenes negativos) y la máscara lo llena al 100%.
            Directo con style no funciona en web: un <svg> no se estira con top/bottom, toma el
            alto de su proporción y el hueco quedaba abajo y cortado. */}
        <View pointerEvents="none" style={tw`absolute -top-5 bottom-0 -left-10 -right-10`}>
          <Mascara width="100%" height="100%" preserveAspectRatio="xMidYMid slice" />
        </View>

        <SafeAreaView style={tw`flex-1 items-center justify-center`}>
          <TouchableOpacity
            style={tw`absolute top-5 left-2.5 px-3 py-3`}
            onPress={() => setTorchOn(!torchOn)}
          >
            <Icon name="flash" variant={torchOn ? 'on' : 'off'} width={20} height={24} />
          </TouchableOpacity>

          {
            (!permission) &&
              <Text>Solicitando permisos de cámara</Text>
          }

          {
            (permission?.granted === false) &&
              <Text>Sin acceso a la cámara</Text>
          }

          {
            scanned &&
              <QRResult
                scannedCode={scanned}
                onClear={() => setScanned(null)}
                onAuthorization={auth => setScannedAuthorization(auth)}
              />
          }
        </SafeAreaView>
      </View>

      <GuardAccessAuthorizationDetailModal
        visible={!!scannedAuthorization}
        authorization={scannedAuthorization}
        communityId={communityId}
        source='qr'
        onRequestClose={() => {
          setScannedAuthorization(null)
          setScanned(null)
        }}
      />
    </>

  );
}
